var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.001,
    height: 38,
    viewBox: "0 0 38.001 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "PASSING",
    className: "cls-1",
    d: "M2709.681,7224.429l-18.266-18.264a.731.731,0,0,0-1.038,0l-18.266,18.264a.735.735,0,0,0,0,1.04l18.266,18.265a.732.732,0,0,0,1.038,0l18.266-18.265A.737.737,0,0,0,2709.681,7224.429Zm-18.785,3.339-2.818-2.817,2.818-2.817,2.818,2.817Zm-.734-6.978-3.426,3.424h-3.275l6.7-6.7Zm-3.426,4.894,3.426,3.426v3.274l-6.7-6.7Zm4.9,3.426,3.425-3.426h3.275l-6.7,6.7Zm3.425-4.9-3.425-3.424v-3.275l6.7,6.7Zm-4.894-8.776-8.778,8.776H2674.4l15.759-15.759Zm-8.778,10.246,8.778,8.776v6.982l-15.759-15.759Zm10.247,8.776,8.777-8.776h6.98l-15.757,15.759Zm8.777-10.246-8.777-8.776v-6.982l15.757,15.759Z",
    transform: "translate(-2671.895 -7205.949)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassing);
export default __webpack_public_path__ + "static/media/passing.60d5618dd02ce2e2b884108c4bcc2d73.svg";
export { ForwardRef as ReactComponent };